import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/images/no-image.png'


const _withScopeId = n => (_pushScopeId("data-v-f296fce2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "product-img-block" }
const _hoisted_2 = {
  key: 1,
  class: "default-img",
  src: _imports_0
}
const _hoisted_3 = { class: "product-name" }
const _hoisted_4 = {
  key: 0,
  class: "withCouponTitle"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LazyImage = _resolveComponent("LazyImage")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["product-card", { highlighted: _ctx.highlighted }]),
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.selectProduct && _ctx.selectProduct(...args)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.image)
        ? (_openBlock(), _createBlock(_component_LazyImage, {
            key: 0,
            src: _ctx.image,
            "src-placeholder": require('../assets/images/no-image.png')
          }, null, 8, ["src", "src-placeholder"]))
        : (_openBlock(), _createElementBlock("img", _hoisted_2))
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("span", null, _toDisplayString(_ctx.product.name), 1)
    ]),
    (_ctx.product.withCoupon)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.$t("cashier.label.coupon")), 1))
      : _createCommentVNode("", true)
  ], 2))
}